<template>
  <div class="deal-price w-100">
    <div>
      <p
        v-if="isFreeDeal"
        class="d-inline-block mr-1"
      >
        FREE
      </p>
      <p
        v-else
        class="d-inline-block mr-1"
      >
        {{ price | currency('$', parseDecimal(price), { thousandsSeparator: ',' }) }}
      </p>
      <p
        v-if="originalPrice"
        class="original d-inline-block"
      >
        {{
          originalPrice | currency('$', parseDecimal(originalPrice), { thousandsSeparator: ',' })
        }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    price: {
      type: [Number, String],
      required: true,
    },
    originalPrice: {
      type: [Number, String],
      default: 0,
    },
    isFree: {
      type: Boolean,
    },
  },
  computed: {
    isFreeDeal() {
      return this.isFree || parseFloat(this.price) <= 0;
    },
  },
  methods: {
    parseDecimal(price) {
      return (parseFloat(price) % 1 !== 0) ? 2 : 0;
    },
  },
};
</script>
<style scoped lang="scss">
@import '~/styles/utils/breakpoints';

.deal-price {
  p {
    font-size: 16px;
    font-weight: 600;
    line-height: 36px;
  }

  .original {
    text-decoration: line-through;
    font-weight: 400;
  }

  &.top-pick-component {
    p {
      color: #fff;
      margin-bottom: 8px;
      font-weight: 500;
      font-size: 24px;
    }

    .original {
      font-size: 14px;
      line-height: 21px;
    }
  }

  &.product-carousel-component {
    display: inline-block;

    p {
      margin-bottom: 0.25rem;
      font-weight: 500;
      font-size: 20px;
      line-height: 32px;
    }

    .original {
      color: #cdcdcd;
      font-size: 14px;
      line-height: 21px;
      margin-bottom: 0;
    }
  }

  &.spotlight-carousel-component,
  &.carousel-component {
    margin: 15px 0 10px;

    p {
      font-size: 20px;
      margin-bottom: 0;
      color: #021414;
    }

    .original {
      font-size: 14px;
      line-height: 21px;
      text-decoration-thickness: 1.5px;
    }
  }

  &.browse-results-component {
    p {
      font-size: 18px;
      margin-bottom: 0;
      color: #021414;
      line-height: 1.7;
    }

    .original {
      color: #434d59;
      font-weight: 100;
      text-decoration-thickness: 1.5px;
    }
  }

  &.carousel-component .original {
    color: #434d59;
    font-size: 20px;
    font-weight: 100;
  }
}

@include media-breakpoint-down(xs) {
  .deal-price {
    &.top-pick-component {
      text-align: center;
    }
  }
}

@include media-breakpoint-up(md) {
  .deal-price {
    &.spotlight-carousel-component {
      p {
        color: #fff;
      }
    }
  }
}
</style>
